/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Suggestion_1Inputs */

const en_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const th_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สายพันธุ์ไหนเหมาะกับมือใหม่`)
};

const ja_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const fr_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const es_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const ru_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const zh_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which strain suits a beginner?`)
};

const vi_chat_suggestion_1 = /** @type {(inputs: Chat_Suggestion_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giống nào hợp với người mới trồng?`)
};

/**
* | output |
* | --- |
* | "Which strain suits a beginner?" |
*
* @param {Chat_Suggestion_1Inputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const chat_suggestion_1 = /** @type {((inputs?: Chat_Suggestion_1Inputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Suggestion_1Inputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_chat_suggestion_1(inputs)
	if (locale === "ja") return ja_chat_suggestion_1(inputs)
	if (locale === "fr") return fr_chat_suggestion_1(inputs)
	if (locale === "es") return es_chat_suggestion_1(inputs)
	if (locale === "ru") return ru_chat_suggestion_1(inputs)
	if (locale === "zh") return zh_chat_suggestion_1(inputs)
	if (locale === "vi") return vi_chat_suggestion_1(inputs)
	return en_chat_suggestion_1(inputs)
});